import { useEffect, useRef } from "react";

import { useAuth } from "react-oidc-context";

import { LoadingOverlay } from "../../components/common/LoadingOverlay";
import { useAppDispatch } from "../../store/hooks";
import { logout } from "../../store/slices/authSlice";
import { clearServiceData } from "../../store/slices/serviceSlice";

function ForceSignOut() {
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const signoutInitiated = useRef(false);

  useEffect(() => {
    const performSignout = async () => {
      // Prevent multiple signout attempts
      if (signoutInitiated.current) {
        return;
      }
      signoutInitiated.current = true;

      try {
        // Clear local state first
        dispatch(logout());
        dispatch(clearServiceData());
        localStorage.removeItem("original_route");

        // Perform OIDC signout redirect
        await auth.signoutRedirect();
      } catch (error) {
        console.error("Error during signout redirect:", error);
        // If signout redirect fails, try to clean up locally
        await auth.removeUser();
        window.location.href = "/signout-callback";
      }
    };

    performSignout();
  }, [auth, dispatch]);

  return <LoadingOverlay />;
}

export default ForceSignOut;
